(() => {
  const header = document.querySelector('.header');
  const headerHeight = header ? header.offsetHeight : 0;

  function removeCurrent() {
    const current = document.querySelector(".dots > li.current");
    if (current) current.classList.remove("current");
  }

  let isScrolling = false;

  const indicators = document.querySelectorAll(".dots a");

  indicators.forEach((indicator, index) => {
    indicator.addEventListener("click", (event) => {
      event.preventDefault();

      const target = document.querySelector(indicator.getAttribute("href"));
      if (!target) return;

      const current = document.querySelector(".dots > li.current");
      const currentIsFirst = current && [...current.parentElement.children].indexOf(current) === 0;
      const targetIsFirst = index === 0;

      removeCurrent();

      isScrolling = true;

      const onScroll = () => {
        const rect = target.getBoundingClientRect();
        if (Math.abs(rect.top) < 2) {
          window.removeEventListener("scroll", onScroll);
          isScrolling = false;
        }
      };

      window.addEventListener("scroll", onScroll);

      const offset = currentIsFirst && !targetIsFirst ? headerHeight * 2 : headerHeight;
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({
        top: targetPosition,
        behavior: "smooth",
      });

      indicator.parentElement.classList.add("current");
    });
  });

  const images = document.querySelectorAll('[id*="product-image"]');

  const observer = new IntersectionObserver(
    (entries) => {
      if(isScrolling) return;

      const visible = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

      if (visible.length > 0) {
        const id = visible[0].target.id;
        const indicator = document.querySelector(`[href="#${id}"]`);
        if (!indicator) return;

        removeCurrent();

        indicator.parentElement.classList.add("current");
      }
    },
    { threshold: 0.5 }
  );

  images.forEach((image) => observer.observe(image));
})();
